require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTablePagination = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _color = _interopRequireDefault(require("color"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _Text = _interopRequireDefault(require("../Typography/Text"));

var _theming = require("../../core/theming");

var _MaterialCommunityIcon = _interopRequireDefault(require("../MaterialCommunityIcon"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/DataTable/DataTablePagination.tsx";

var DataTablePagination = function (_React$Component) {
  (0, _inherits2["default"])(DataTablePagination, _React$Component);

  function DataTablePagination() {
    (0, _classCallCheck2["default"])(this, DataTablePagination);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(DataTablePagination).apply(this, arguments));
  }

  (0, _createClass2["default"])(DataTablePagination, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          page = _this$props.page,
          numberOfPages = _this$props.numberOfPages,
          onPageChange = _this$props.onPageChange,
          style = _this$props.style,
          theme = _this$props.theme,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["label", "page", "numberOfPages", "onPageChange", "style", "theme"]);
      var labelColor = (0, _color["default"])(theme.colors.text).alpha(0.6).rgb().string();
      return React.createElement(_reactNative.View, (0, _extends2["default"])({}, rest, {
        style: [styles.container, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 59
        }
      }), React.createElement(_Text["default"], {
        style: [styles.label, {
          color: labelColor
        }],
        numberOfLines: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60
        }
      }, label), React.createElement(_IconButton["default"], {
        icon: function icon(_ref) {
          var size = _ref.size,
              color = _ref.color;
          return React.createElement(_MaterialCommunityIcon["default"], {
            name: "chevron-left",
            color: color,
            size: size,
            direction: _reactNative.I18nManager.isRTL ? 'rtl' : 'ltr',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 65
            }
          });
        },
        color: theme.colors.text,
        disabled: page === 0,
        onPress: function onPress() {
          return onPageChange(page - 1);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63
        }
      }), React.createElement(_IconButton["default"], {
        icon: function icon(_ref2) {
          var size = _ref2.size,
              color = _ref2.color;
          return React.createElement(_MaterialCommunityIcon["default"], {
            name: "chevron-right",
            color: color,
            size: size,
            direction: _reactNative.I18nManager.isRTL ? 'rtl' : 'ltr',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 78
            }
          });
        },
        color: theme.colors.text,
        disabled: page === numberOfPages - 1,
        onPress: function onPress() {
          return onPageChange(page + 1);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 76
        }
      }));
    }
  }]);
  return DataTablePagination;
}(React.Component);

exports.DataTablePagination = DataTablePagination;
(0, _defineProperty2["default"])(DataTablePagination, "displayName", 'DataTable.Pagination');

var styles = _reactNative.StyleSheet.create({
  container: {
    justifyContent: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 16
  },
  label: {
    fontSize: 12,
    marginRight: 44
  }
});

var _default = (0, _theming.withTheme)(DataTablePagination);

exports["default"] = _default;